import { z } from "zod";

// Define the schema for a line item in the quotation
export const quotationItemSchema = z.object({
  id: z.number().optional(), // Only present when editing an existing item
  item_id: z.number({ required_error: "Product is required" }),
  quantity: z.number().min(0.01, { message: "Quantity must be greater than 0" }),
  rate: z.number().min(0, { message: "Rate must be 0 or greater" }),
  discount_percent: z.number().min(0).max(100).default(0),
  tax_rate_id: z.number().nullable().optional(), // Add tax_rate_id field
  amount: z.number(),
  description: z.string().optional().nullable(),
  godown_id: z.number({ required_error: "Warehouse is required" }),
  unit_id: z.number().optional(), // Add unit_id field for API
  applied_sale_rule_id: z.number().nullable().optional(), // Add applied_sale_rule_id field
  // Additional display fields
  item_name: z.string().optional(),
  item_code: z.string().optional(),
  discount_amount: z.number().optional(),
  taxable_amount: z.number().optional(),
  tax_amount: z.number().optional(),
});

// Define the schema for the entire quotation form
export const quotationSchema = z.object({
  party_id: z.number({ required_error: "Customer is required" }),
  site_id: z.number({ required_error: "Site is required" }),
  transaction_date: z.date({ required_error: "Date is required" }),
  valid_until_date: z.date().optional().nullable(),
  reference_number: z.string().optional().nullable(),
  terms_and_conditions: z.string().optional().nullable(),
  notes: z.string().optional().nullable(),
  total_amount: z.number().min(0),
  items: z.array(quotationItemSchema),
});

// Create a type for form values based on the schema
export type QuotationFormValues = z.infer<typeof quotationSchema>;

// Create a type for line items
export type QuotationItemFormValues = z.infer<typeof quotationItemSchema>; 